export default __webpack_public_path__ + "static/media/define1.2e5490a5.png";